'use client';

import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FC } from 'react';

import { SetShowDialog } from '../../../types';
import { LeasingRight } from '../../../types/leases';
import { dayjs } from '../../../utils';
import { MustTakesTable } from '../mustTakesTable';

type LeaseUtilizationProps = {
	leasingRight: LeasingRight;
	setShowDialog: SetShowDialog;
	getUrlToSubscriptionPage: (...x: any) => string;
};

export const LeaseUtilization: FC<LeaseUtilizationProps> = ({
	leasingRight,
	setShowDialog,
	getUrlToSubscriptionPage,
}) => {
	const today = dayjs();

	const hasActiveMustTakes = leasingRight.countAndRates.some((countAndRate) =>
		countAndRate.history.find(
			(history) =>
				dayjs(history.startDate).isSameOrBefore(today) &&
				dayjs(history.endDate).isSameOrAfter(today) &&
				history.minCount > 0,
		),
	);

	return (
		<>
			<Box display='flex' flexDirection='row' gap='1em' mt='1.5em' mb='1em'>
				<Typography variant='h5' fontWeight='bold' alignContent='center'>
					Must Takes
				</Typography>
			</Box>
			<Box>
				{!hasActiveMustTakes && (
					<Typography variant='body1' alignContent='center'>
						Lease does not currently have any Active Must Takes
					</Typography>
				)}
				{hasActiveMustTakes && (
					<>
						<Typography variant='body1' mb='1em' fontStyle='italic' color='info'>
							*Current utilization as of {today.format('M/D/YYYY')}
						</Typography>
						<MustTakesTable
							leasingRight={leasingRight}
							setShowDialog={setShowDialog}
							getUrlToSubscriptionPage={getUrlToSubscriptionPage}
						/>
					</>
				)}
			</Box>
		</>
	);
};
